import { useQuery } from '@tanstack/react-query'

import { PrivateAPI } from '../utils/api'

type TCheckoutSummaryAddon = {
  cost: number
  type: 'WARRANTY_12' | 'WARRANTY_24' | 'IXI_FLASHER_SURCHARGE'
}

type TCheckoutPaymentMethod = {
  id: string
  address: {
    line1: string
    line2: string
    city: string
    region: string
    postcode: string
    country: string
  }
  card: {
    brand: string
    expMonth: string
    expYear: number
    last4: string
  }
  nickname?: string
  primary: boolean
}

type TCheckoutCreditItem = {
  amount: number
  description: string
}

type TCheckoutDtcOnlyPayment = {
  amount: number
  creditCost?: number
  mode: 'CARD' | 'CREDITS' | 'NONE'
  required: boolean
  status?: 'FAILED' | 'PENDING' | 'SUCCEEDED'
  totalAmount: number
  vatAmount: number
}

type TCheckoutSummary = {
  adHocCreditBaseCost: number
  availableAddons: TCheckoutSummaryAddon[]
  creditBalance: number
  creditItems: TCheckoutCreditItem[]
  creditsTotal: number
  dtcOnlyPayment: TCheckoutDtcOnlyPayment
  isMaster: boolean
  paymentMethods: TCheckoutPaymentMethod[]
  requiresPaymentMethod: boolean
  shouldChargeVat: boolean
}

type TCheckoutSummaryResponse = {
  checkout: TCheckoutSummary
}

const useCheckoutSummary = (
  analysedFileId: string,
  enabled: boolean = true,
) => {
  return useQuery({
    queryKey: ['checkout-summary', analysedFileId],
    queryFn: async () => {
      const response = await PrivateAPI<TCheckoutSummaryResponse>({
        url: `/uploads/analyse/${analysedFileId}/checkout`,
        method: 'get',
      })

      return response.data.checkout
    },
    enabled: enabled && Boolean(analysedFileId),
  })
}

export type {
  TCheckoutCreditItem,
  TCheckoutDtcOnlyPayment,
  TCheckoutPaymentMethod,
  TCheckoutSummary,
  TCheckoutSummaryAddon,
}

export default useCheckoutSummary
